import React, { useEffect, useState } from 'react';
import { SIGNING_DAY } from '../config/signingDay';

function parts(ms) {
    const s = Math.max(0, Math.floor(ms / 1000));
    return {
        days: Math.floor(s / 86400),
        hours: Math.floor((s % 86400) / 3600),
        mins: Math.floor((s % 3600) / 60),
        secs: s % 60,
    };
}

const Cell = ({ value, label }) => (
    <div className="flex flex-col items-center">
        <span
            className="font-mono font-black text-3xl sm:text-5xl text-white tabular-nums"
            style={{ textShadow: '0 0 18px rgba(0,229,255,.35)' }}
        >
            {String(value).padStart(2, '0')}
        </span>
        <span className="text-[10px] sm:text-xs uppercase tracking-widest text-zinc-500 mt-1">{label}</span>
    </div>
);

const Sep = () => (
    <span className="font-mono font-black text-2xl sm:text-4xl text-white/15 self-start mt-1 select-none">:</span>
);

export default function SigningDayCountdown() {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, []);

    const remaining = SIGNING_DAY.getTime() - now;
    if (remaining <= 0) {
        return (
            <div className="font-display font-black text-2xl sm:text-3xl text-truth uppercase tracking-widest"
                 style={{ filter: 'drop-shadow(0 0 12px rgba(57,255,20,.5))' }}>
                Signing Day is live
            </div>
        );
    }
    const p = parts(remaining);
    return (
        <div className="flex items-end justify-center gap-3 sm:gap-5">
            <Cell value={p.days} label="Days" />
            <Sep />
            <Cell value={p.hours} label="Hrs" />
            <Sep />
            <Cell value={p.mins} label="Min" />
            <Sep />
            <Cell value={p.secs} label="Sec" />
        </div>
    );
}
